import OutlinedCard from "components/OutlinedCard";
import PageLayout from "components/PageLayout";
import PageTitle from "components/PageTitle";
import Tabs from "components/Tabs";
import OfficesSection from "./components/OfficesSection";
import DepartmentsSection from "./components/DepartmentsSection";
import OrderIncompleteReasonsSection from "./components/OrderIncompleteReasonsSection";

const SettingsPage: React.FC = () => {
  return (
    <PageLayout maxWidth="md">
      <PageTitle>Inställningar</PageTitle>

      <OutlinedCard sx={{ p: 0 }}>
        <Tabs
          queryKey="section"
          values={[
            {
              key: "offices",
              label: "Kontor",
              content: <OfficesSection />,
            },
            {
              key: "departments",
              label: "Avdelningar",
              content: <DepartmentsSection />,
            },
            {
              key: "status-x",
              label: "Status X",
              content: <OrderIncompleteReasonsSection />,
            },
          ]}
        />
      </OutlinedCard>
    </PageLayout>
  );
};

export default SettingsPage;
